import { ContractEnvelopeValidationSchema } from '@/features/privateCompanyLeadsFunnel/schemas/contractEnvelope.schema'
import { ContractEnvelopeData } from '@/features/privateCompanyLeadsFunnel/types/privateCompanyLeadContractEnvelope'

export const updateContractEnvelopeDefaultValues = (contractEnvelope?: ContractEnvelopeData) => {
  const establishmentCompanyBranchDefaultValues: ContractEnvelopeValidationSchema = {
    contract_attributes: {
      valid_envelope_attributes: {
        contractee_attributes: {
          signable_id: contractEnvelope?.contractee
            ? {
                value: contractEnvelope.contractee.id,
                label: contractEnvelope.contractee.full_name,
              }
            : undefined,
        },
        contractor_attributes: {
          signable_id: contractEnvelope?.contractor
            ? {
                value: contractEnvelope.contractor.id,
                label: contractEnvelope.contractor.full_name,
              }
            : undefined,
        },
        surety_attributes: {
          signable_id: contractEnvelope?.surety
            ? {
                value: contractEnvelope.surety.id,
                label: contractEnvelope.surety.full_name,
              }
            : undefined,
        },
      },
    },
  }

  return establishmentCompanyBranchDefaultValues
}
